import React from 'react';
import ResponsiveNavbar from '../Components/Organisms/NavbarOrganism/ResponsiveNavbar';
import FooterContent from '../Components/Molecules/FooterMolecules/FooterContent';
import TermOfServiceContent from '../Components/Organisms/TermOfServiceOrganism/TermOfServiceContent';


const TermsOfService = () => {
  return (
    <>
        <ResponsiveNavbar/>
        <TermOfServiceContent/>
        <FooterContent/>
    </>
)}

export default TermsOfService
